<template>
  <b-modal id="modal-errorMsg" centered hide-header hide-footer @close="$root.clearErrorMsg; checkPath();" size="md"
    @hidden="$root.clearErrorMsg; checkPath();">
    <div class="text-left">
      <img class="mb-3" :src="require(`./assets/images/action/${$root.variant}.png`)" alt="" height="56px" width="56px">
      <p class="dialog-title" v-html="$root.modal.title"></p>
      <p class="dialog-msg font-weight-normal">{{ $root.modal.msg }}</p>
      
      <div class="text-center">
        <b-button variant="primary" block @click="$bvModal.hide('modal-errorMsg');" class="mt-3">{{
          $t('close')
        }}</b-button>

      </div>

    </div>
  </b-modal>
</template>
<script>
export default {
  methods: {
    checkPath() {
      if (this.$route.path.includes('withdraw') && this.$root.modal.variant == 'info') {
        this.$router.go(-1);

      }
      this.$bvModal.hide('modal-errorMsg');
    }
  }
}
</script>